import {
    UPDATE_AREA_START,
    UPDATE_AREA_SUCCESS,
    UPDATE_AREA_ERROR
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.areas.update, action = {type: ''}) => {
    switch (action.type) {
        case UPDATE_AREA_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case UPDATE_AREA_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case UPDATE_AREA_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/updateAreaReducer.js